import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-bottom-sheet-header',
  templateUrl: './bottom-sheet-header.component.html',
  styleUrls: ['./bottom-sheet-header.component.scss']
})
export class BottomSheetHeaderComponent implements OnInit {

  @Input() title: string;
  @Output() closeBottomSheet = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  closeOpenBottomSheet() {
    this.closeBottomSheet.emit(true);
  }
}
